import { LongTextInput, SimpleForm, TextInput } from "react-admin";

import CodeEditorInput from "../components/inputs/CodeEditorInput";
import DefaultToolbar from "../components/DefaultToolbar";
import React from "react";

const Form = (props) => (
  <SimpleForm {...props} redirect="edit" toolbar={<DefaultToolbar />}>
    <TextInput source="name" />
    <LongTextInput source="description" />
    <CodeEditorInput source="php_code" />
  </SimpleForm>
);
export default Form;
